module.exports = __webpack_public_path__ + "ath_game_web/img/8.7.c481b420.png";